import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Result } from 'antd';

const NotFound = () => {
  return (
    <div className='flex min-h-[70vh] items-center justify-center px-4 text-center sm:px-6 md:px-8'>
      <Result
        status='404'
        title='Erro 404'
        subTitle='Ops, página não encontrada...'
        extra={
          <Link to={'/'}>
            <Button type='primary'>Ir para tela principal</Button>
          </Link>
        }
      />
    </div>
  );
};

export default NotFound;
